import React, { useState, useEffect, useRef } from 'react';
import { supabase } from "../services/supabase";
import { useParams, useNavigate } from "react-router-dom";
import { RiArrowLeftFill } from "@remixicon/react";

const RandomVoucher = () => {
    const { collectionid } = useParams();
    const [isOpen, setIsOpen] = useState(false);
    const [isRandomPlayer, setRandomPlayer] = useState(false);
    const [isGettingVoucher, setGettingVoucher] = useState(false);
    const navigate = useNavigate();
    console.log(collectionid)

    const fetchPlayersAndVouchers = async () => {
        // Fetch picked couvher
        const { data: pickedVoucher, error: pickedVoucherError } = await supabase
            .from('event')
            .select(`
          *,
          player:playerid (avatar,name)
          ,
          voucher:voucherid (price)
        `)
            .eq('collectionid', collectionid)
            .order('id', { ascending: false })
            ;

        if (pickedVoucherError) console.error(pickedVoucherError);
        else {
            //pickedVoucher.sort((a, b) => b.voucher.price - a.voucher.price);
            setPickedVoucher(pickedVoucher);
        }
        var listPlayerPicked = []
        var listVoucherPicked = []

        pickedVoucher.map((p, index) => {
            listPlayerPicked.push(p.playerid)
            listVoucherPicked.push(p.voucherid)
        })
        // Fetch players
        let { data: playersData, error: playersError } = await supabase
            .from('player')
            .select('*');
        if (playersError) console.error(playersError);

        else {
            playersData = playersData.filter(p => !listPlayerPicked.includes(p.id));
            setPlayers(playersData);
        }

        // Fetch vouchers
        const { data: vouchersData, error: vouchersError } = await supabase
            .from('voucher')
            .select('*')
            .order('id', { ascending: true })
            ;
        if (vouchersError) console.error(vouchersError);
        else {
            const shuffledList = shuffleArray(vouchersData);
            setVouchers(shuffledList);
            CalculateAvailableVoucher(shuffledList, listVoucherPicked);

        }
        setSelectedPlayer(null)

    };
    useEffect(() => {

        fetchPlayersAndVouchers();
    }, []);

    const [players, setPlayers] = useState([]);
    const [pickedVoucher, setPickedVoucher] = useState([]);
    const [selectedPlayer, setSelectedPlayer] = useState(null);
    const [selectedVoucher, setSelectedVoucher] = useState(null);
    const [selectedColor, setSelectedColor] = useState(null);

    function shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const randomIndex = Math.floor(Math.random() * (i + 1));
            [array[i], array[randomIndex]] = [array[randomIndex], array[i]]; // Swap elements
        }
        return array;
    }
    const CalculateAvailableVoucher = (data, vouchersPicked) => {
        var listVoucher = []
        data.forEach((v, index) => {
            var numberPicked = vouchersPicked.filter(p => p == v.id).length;
            v.remain = v.quantity - numberPicked;
            listVoucher.push(v)
        })
        setVouchers(listVoucher);
    }

    const GetRandomPlayer = () => {
        setRandomPlayer(true)

        setTimeout(function () {

            if (players) {
                if (players.length == 0) {
                    alert('There is no player available')
                    setRandomPlayer(false)
                    return;
                }
                const max = players.length - 1;
                const min = 0;
                const randomIndex = Math.floor(Math.random() * (max - min + 1) + min);
                console.log(randomIndex)
                setSelectedPlayer(players[randomIndex]);
            }

        }, 500);

        setRandomPlayer(false)

    }
    function weightedRandom(prizePool) {
        const totalPrizes = prizePool.length;
        const weights = prizePool.map((_, index) => {
            const normalizedIndex = index / totalPrizes;
            // Phân phối Gaussian (giữa và cuối cao hơn)
            return Math.exp(-Math.pow(normalizedIndex - 0.75, 2) / 0.1);
        });

        // Tính tổng trọng số
        const totalWeight = weights.reduce((sum, weight) => sum + weight, 0);

        // Tạo ngẫu nhiên theo trọng số
        const random = Math.random() * totalWeight;
        let cumulativeWeight = 0;
        for (let i = 0; i < prizePool.length; i++) {
            cumulativeWeight += weights[i];
            if (random <= cumulativeWeight) {
                return prizePool[i];
            }
        }
    }
    // Danh sách voucher với mệnh giá và số lượng
    const [vouchers, setVouchers] = useState([]);
    // Hàm random voucher cho một mệnh giá cụ thể
    const randomVoucherForPlayer = async () => {
        if (!selectedPlayer) {
            alert('Please pick player to get the voucher')
            return;
        }
        setGettingVoucher(true)
        const availableVouchers = vouchers.filter(voucher => voucher.remain > 0);

        const selectedVoucher = weightedRandom(availableVouchers);

        setSelectedVoucher(selectedVoucher.price);
        setSelectedColor(getColorByValue(selectedVoucher.price))
        await supabase.from('event').insert({
            collectionid,
            playerid: selectedPlayer.id,
            voucherid: selectedVoucher.id,
        });

        setIsOpen(true);
        setGettingVoucher(false)
        fetchPlayersAndVouchers();

    };
    const getColorByValue = (value) => {
        switch (value) {
            case 2000000:
                return 'gold'; // Màu vàng
            case 1500000:
                return 'darkblue'; // Màu xanh dương đậm
            case 1000000:
                return 'green'; // Màu xanh lá cây
            case 800000:
                return 'orange'; // Màu cam
            case 500000:
                return 'red'; // Màu đỏ
            case 300000:
                return 'purple'; // Màu tím
            case 200000:
                return 'gray'; // Màu xám
            default:
                return 'gray'; // Không có màu
        }
    };
    return (
        <>
            {isOpen && <WinnerPopup player={selectedPlayer} voucher={selectedVoucher} color={selectedColor} onClose={() => setIsOpen(false)} />}
            <div className="absolute top-10 left-8">
                <button className="bg-gray-800 rounded-md p-4" title='Back to Home' onClick={() => navigate('/')}>
                    <RiArrowLeftFill className="text-white-500" />
                </button>
            </div>
            <div className="flex items-center justify-center py-1" style={{ zIndex: -1000 }}>

                <div className="flex w-full">
                    <div className="w-1/3 bg-white shadow-lg rounded-lg p-6 m-2">
                        <h1 className="text-2xl font-bold text-gray-800 mb-6">Cơ cấu giải thưởng</h1>
                        <div className="overflow-x-auto">
                            <table className="min-w-full border-collapse border border-gray-300 text-sm text-left">
                                <thead>
                                    <tr className="bg-gray-100">
                                        <th className="px-6 py-3 border border-gray-300 text-gray-700 font-semibold">MỆNH GIÁ</th>
                                        <th className="px-6 py-3 border border-gray-300 text-gray-700 font-semibold">SỐ LƯỢNG</th>
                                        <th className="px-6 py-3 border border-gray-300 text-gray-700 font-semibold">CÒN LẠI</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {vouchers && vouchers.sort((a, b) => b.price - a.price).map((voucher) => (
                                        <tr className="hover:bg-gray-50" key={voucher.id}>
                                            <td className="px-6 py-3 border border-gray-300 text-yellow-600 font-semibold" style={{ color: getColorByValue(voucher.price) }}>
                                                {voucher.price.toLocaleString()}đ</td>
                                            <td className="px-6 py-3 border border-gray-300 text-gray-800">{voucher.quantity}</td>
                                            <td className="px-6 py-3 border border-gray-300 text-gray-800">{voucher.remain}</td>
                                        </tr>
                                    ))}
                                    <tr className="hover:bg-red-400 text-bold bg-red-500" key={111}>
                                        <td className="px-6 py-3 border border-gray-300 text-white font-semibold" >
                                            {vouchers.reduce((sum, item) => sum + item.price * item.quantity, 0).toLocaleString()}</td>
                                        <td className="px-6 py-3 border border-gray-300 text-white-800">{vouchers.reduce((sum, item) => sum + item.quantity, 0)}</td>
                                        <td className="px-6 py-3 border border-gray-300 text-white-800">{vouchers.reduce((sum, item) => sum + item.remain, 0)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="space-x-4 text-center">
                            <button
                                onClick={() => GetRandomPlayer()}
                                disabled={isRandomPlayer}
                                className={`bg-orange-600 text-white-500 font-bold py-3 px-6 mt-4 rounded-full hover:bg-orange-400`}>
                                Người tiếp theo ({players.length})
                            </button>
                        </div>
                    </div>

                    <div className="w-1/3 bg-white shadow-lg rounded-lg p-6 flex flex-col items-center  m-2">
                        <h2 className="text-lg font-bold text-gray-800 mb-4">Người nhận voucher</h2>
                        {selectedPlayer ? <>
                            <div class="bg-transparent-300">
                                <img class="object-contain rounded-md mb-4" style={{ width: '20rem' }} src={selectedPlayer?.avatar} alt="Avatar" loading="lazy" />
                            </div>
                            <p className="text-gray-700 font-bold mb-4" style={{ fontSize: '24px', textTransform: 'uppercase' }}>{selectedPlayer?.name}</p>
                        </> : <>
                            <div className="flex justify-center w-full h-500 bg-gray-900 rounded-md p-20">
                                <div className="w-20 h-20 block border-4 border-transparent border-t-blue-500 border-l-green-400 rounded-full animate-spin bg-gradient-to-r from-blue-500 to-green-400"></div>
                                <p className="mt-6 ml-6 text-lg font-semibold text-white animate-pulse">
                                    Người chơi tiếp theo...
                                </p>
                            </div>
                        </>}


                        <div className="flex space-x-4">

                            <button
                                onClick={() => randomVoucherForPlayer()}
                                disabled={isGettingVoucher || !selectedPlayer}
                                className={`text-white-500 font-bold py-3 px-6 mt-4 rounded-full ${isGettingVoucher || !selectedPlayer ? 'bg-gray-500 hover:bg-gray-600' : 'bg-green-500 hover:bg-green-600'}`}>
                                Nhận voucher
                            </button>
                        </div>
                    </div>
                    <div className="w-1/3 bg-white shadow-lg rounded-lg p-6 block  m-2">
                        <h1 className="text-2xl font-bold text-center text-gray-800 mb-6">Kết quả </h1>

                        <div className="bg-white px-4 py-6 rounded-b-2xl no-scroll-y" style={{ maxHeight: '700px', overflowY: "scroll" }}>
                            {
                                pickedVoucher && pickedVoucher.map((picked, index) => {
                                    return <>
                                        <div key={index} className="flex items-center justify-center bg-gray-100 rounded-lg py-4 px-4 mb-4 relative" style={{ width: '100%' }}>
                                            <div className="absolute top-0 left-0 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-br-lg">
                                                {pickedVoucher.length > 0 ? pickedVoucher.length - index : 0}
                                            </div>
                                            <div className="w-8 h-8 mr-4">
                                                <img
                                                    src={`${picked.player.avatar}`}
                                                    alt={picked.player.name}
                                                    className="rounded-full object-cover w-full h-full"
                                                />
                                            </div>
                                            <span className="text-gray-700 font-semibold">{picked.player.name}</span>

                                            <span className="ml-2 text-blue-500 font-bold text-md" style={{ color: getColorByValue(picked.voucher.price) }}>
                                                {picked.voucher.price.toLocaleString()}đ</span>
                                        </div>
                                    </>
                                })
                            }
                        </div>
                    </div>

                </div>
            </div>


        </>

    );
};

export default RandomVoucher;


const WinnerPopup = ({ player, voucher, color, onClose }) => {
    const [selectedPlayer, setSelectedPlayer] = useState(player);
    let canvasRef = useRef(null);
    const MAX_PARTICLES = 500;
    const MAX_FIREWORKS = 10;
    let fireworkCreationCooldown = 0;
    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        const fireworks = [];
        const particles = [];

        // Function to generate random color
        const getRandomColor = () => {
            const colors = [
                'rgb(255, 0, 0)',    // Red
                'rgb(0, 255, 0)',    // Green
                'rgb(0, 0, 255)',    // Blue
                'rgb(255, 255, 0)',  // Yellow
                'rgb(255, 0, 255)',  // Magenta
                'rgb(0, 255, 255)',  // Cyan
                'rgb(255, 165, 0)',  // Orange
                'rgb(238, 130, 238)', // Violet
                'rgb(255, 192, 203)', // Pink
            ];
            return colors[Math.floor(Math.random() * colors.length)];
        };

        class Firework {
            constructor(x, y) {
                this.x = x;
                this.y = y;
                this.targetY = y - Math.random() * 200 - 100;
                this.speed = 2 + Math.random() * 2;
                this.exploded = false;
                this.color = getRandomColor();
            }

            update() {
                if (!this.exploded && this.y > this.targetY) {
                    this.y -= this.speed;
                } else {
                    this.exploded = true;
                    this.createParticles();
                }
            }

            createParticles() {
                if (particles.length < MAX_PARTICLES) {
                    for (let i = 0; i < 50; i++) {
                        particles.push(new Particle(this.x, this.y, this.color));
                    }
                }
            }

            draw() {
                if (!this.exploded) {
                    ctx.fillStyle = this.color;
                    ctx.beginPath();
                    ctx.arc(this.x, this.y, 3, 0, Math.PI * 2);
                    ctx.fill();

                    // Add trail effect
                    ctx.fillStyle = `rgba(${this.color.slice(4, -1)}, 0.3)`;
                    ctx.beginPath();
                    ctx.arc(this.x, this.y + 5, 2, 0, Math.PI * 2);
                    ctx.fill();
                }
            }
        }

        class Particle {
            constructor(x, y, color) {
                this.x = x;
                this.y = y;
                this.color = color;
                this.angle = Math.random() * Math.PI * 2;
                this.speed = Math.random() * 5 + 2;
                this.lifetime = Math.random() * 100 + 50;
                this.opacity = 1;
            }

            update() {
                this.x += Math.cos(this.angle) * this.speed;
                this.y += Math.sin(this.angle) * this.speed;
                this.opacity -= 0.02;
                this.speed *= 0.98; // Add slight deceleration
            }

            draw() {
                ctx.fillStyle = `rgba(${this.color.slice(4, -1)}, ${this.opacity})`;
                ctx.beginPath();
                ctx.arc(this.x, this.y, 2, 0, Math.PI * 2);
                ctx.fill();
            }
        }

        function animate() {
            ctx.fillStyle = 'rgba(0, 0, 0, 0.2)';
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            // Throttle firework creation
            if (fireworkCreationCooldown <= 0 && fireworks.length < MAX_FIREWORKS) {
                fireworks.push(new Firework(Math.random() * canvas.width, canvas.height));
                fireworkCreationCooldown = 20; // Adjust cooldown time for fewer fireworks
            } else {
                fireworkCreationCooldown--;
            }

            fireworks.forEach((firework, index) => {
                firework.update();
                firework.draw();
                if (firework.exploded) {
                    fireworks.splice(index, 1);
                }
            });

            particles.forEach((particle, index) => {
                particle.update();
                particle.draw();
                if (particle.opacity <= 0) {
                    particles.splice(index, 1);
                }
            });

            requestAnimationFrame(animate);
        }

        animate();

        // Handle window resize
        const handleResize = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };
        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => {
            window.removeEventListener('resize', handleResize);
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        };
    }, []);

    return (

        <>
            <div className="fixed inset-0 flex items-center justify-center bg-black" style={{ zIndex: 99 }}>
                <canvas
                    ref={canvasRef}
                    className="fixed top-0 left-0 w-full h-full pointer-events-none bg-black" style={{ zIndex: -1 }}
                />
                <div class="max-w-lg mx-auto p-6 bg-gradient-to-r from-yellow-400 to-red-400 text-white rounded-xl shadow-lg text-center">

                    <div class="text-6xl mb-4">🎉</div>

                    <h1 class="text-3xl font-bold mb-2">Chúc mừng {selectedPlayer?.name}!</h1>

                    <p class="text-lg mb-6">
                        Bạn đã nhận được <span class="font-bold text-2xl">voucher {voucher.toLocaleString()}đ</span>.
                    </p>

                    <button onClick={
                        () => {
                            onClose()
                            canvasRef = null;
                        }
                    } class="bg-white text-yellow-500 font-bold py-3 px-6 rounded-full hover:bg-yellow-100 transition">
                        Tiếp tục quay số
                    </button>
                </div>
            </div>


        </>
    )
}
